const SVGRotateLeft = () => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M3 12a9 9 0 1 0 3.36-7' />
      <path d='M3 4v6h6' />
    </svg>
  )
}

export default SVGRotateLeft
